export default __webpack_public_path__ + "static/hero-92b27ad811b93ce5afa34f7d38e7e423.png";